$(".Index_object_gallery_list_detail_innerloops_innerboxs_maincolumn_new").click(function () {
  $(this).next(".Index_object_gallery_list_detail_innerloops_innerboxs_mainpopup_new").addClass("active");
})

$(".close_popup_new").click(function () {
  $(".Index_object_gallery_list_detail_innerloops_innerboxs_mainpopup_new").removeClass("active");
})

$(".collection-looks__see-all__btn").click(function () {
  $(".Index_object_gallery_list_detail_innerloops_mainboxs_hidden_new").toggleClass("active");
  $(this).toggleClass("active");
})


/* Index_object_gallery_list_slider */
new Swiper('.Index_object_gallery_list_slider', {
  loop: false,
  grabCursor: false,
  spaceBetween: 0,
  slidesPerGroup: 1,
  slidesPerView: 1,
  watchSlidesProgress: true,
  draggable:!0,
  autoHeight:!1,
  watchOverflow:!0,
  threshold:10,
  mousewheel:{
    forceToAxis:!0
  },
  direction: "vertical",
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  freeMode:!0,
  observer: true,
  observeParents: true
})

/* Index_object_gallery_list_slider_single_popup */
const swiper = new Swiper('.Index_object_gallery_list_slider_single_popup', {
  loop: false,
  grabCursor: false,
  spaceBetween: 0,
  slidesPerGroup: 1,
  slidesPerView: 1,
  watchSlidesProgress: true,
  draggable:!0,
  autoHeight:!1,
  watchOverflow:!0,
  threshold:10,
  mousewheel:{
    forceToAxis:!0
  },
  direction: "vertical",
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: ".swiper-pagination",
    type: "fraction",
  },
  freeMode:!0,
  observer: true,
  observeParents: true
})

$(".open_signle_popup").click(function () {
  var index = $(this).attr("slider_number");
  console.log(index)
  $(".Index_object_gallery_list_detail_innerloops_innerboxs_mainpopup_new").addClass("active");
  swiper.slideTo(index, 0);
})


$("body").addClass("nohover");
$(".size_guide_content td, .size_guide_content th")
  .attr("tabindex", "1")
  .on("touchstart", function() {
    $(this).focus();
});

$(".mute_video").click(function(){
  $(this).removeClass("active");
  $(this).parents(".media-banner__content").find(".unmute_video").addClass("active");
  var width = $(window).width();
  if(width < 576)
  {
    $(this).parents(".media-banner__content").find(".mobile_video").prop("muted",0)
  }
  else
  {
    $(this).parents(".media-banner__content").find(".desktop_video").prop("muted",0)
    $(this).parents(".media-banner__content").find(".both_video").prop("muted",0)
  }
})
$(".unmute_video").click(function(){
  $(this).removeClass("active");
  $(this).parents(".media-banner__content").find(".mute_video").addClass("active");
  $(this).parents(".media-banner__content").find("video").prop("muted",1)
})
